import { ReactElement } from 'react';
import { useDialog } from '~/hooks';
import { DialogSection } from '../dialog-section.component';
import { StyledModal as Dialog } from '../dialog.style';

interface Props {
  target: ReactElement;
}

export const PerchDualBillingExplainerDialog = ({ target }: Props) => {
  const { isOpen, close, TargetComponent } = useDialog(target);

  return (
    <>
      {TargetComponent}
      <Dialog isOpen={isOpen} onDismiss={close} aria-label="Perch Dual Billing Explainer">
        <Dialog.Header title="How do I save with two bills?" onClose={close} />
        <DialogSection title="Will I pay more with two bills?">
          No. As a community solar member, you earn solar credits that lower your utility bill.
          Together, your Perch bill and your utility bill will cost less than what you would have
          paid without community solar. Your savings begin once your solar farm starts generating
          energy.
        </DialogSection>
        <DialogSection title="What's a solar credit?">
          A solar credit is the dollar value of the clean energy your solar farm produces on your
          behalf. Each month, Perch applies your credits to your utility bill, so you pay less for
          electricity than you would buying it directly from your utility.
        </DialogSection>
        <DialogSection title="Why will I still receive a bill from my utility?">
          Your solar credits usually won't cover 100% of your electricity costs in a month, so
          you'll pay the remaining balance to your utility. Your utility bill also includes delivery
          charges for bringing electricity to your home. You'll still see these charges even in
          months when your credits cover all of your usage.
        </DialogSection>
        <Dialog.FooterStacked primaryText="Close" onSubmit={close} />
      </Dialog>
    </>
  );
};
